/**
* Helper object to get and set cookies
*/
var Cookies = {};

/**
* @return {Object}
*/
Cookies.getAll = function () {
   const cookies = {};
   document.cookie.split(";").forEach(function (segment) {
      const parts = segment.trim().split("=");
      cookies[parts.shift()] = decodeURIComponent(parts.join("="));
   });
   return cookies;
};

/**
* @param {String} name
* @return {String|null}
*/
Cookies.get = function (name) {
   const all = Cookies.getAll();
   return typeof all[name] !== "undefined" ? all[name] : null;
};

/**
* Create a time string for usage in cookies
*
* @param {Date|String} date
* @return {String}
*/
Cookies.createDateString = function (date) {
   if (typeof date === "string") {
      return date;
   } else if (typeof date === "number") {
      const t = new Date();
      t.setTime(date);
      date = t;
   }
   return date.toUTCString();
};

/**
* Create a time string for usage in cookies
*
* @param {String} name
* @param {String} value
* @param {String|Date} expiration
* @param {String} path
* @return {Object}
*/
Cookies.set = function (name, value, expiration, path) {
   const cookie = [name + "=" + value];
   if (expiration) {
      cookie.push("expires=" + Cookies.createDateString(expiration));
   }
   path = typeof path === "string" && path !== "" ? path : "/";
   cookie.push("path=" + path);
   document.cookie = cookie.join("; ");
   return Cookies;
};

/**
* @param {String} name
* @return {Object}
*/
Cookies.delete = function (name) {
   document.cookie =
      name + "=; expires=Thu, 31 Dec 1970 00:00:00 UTC; path=/";
   return Cookies;
};

/**
* Delete all cookies which names doesn't exist in the passed list of names.
*
* @param {Object} names
* @return {Object}
*/
Cookies.filter = function (names) {
   if (typeof name === "object") {
      names.forEach(function (cookie) {
         Cookies.delete(cookie);
      });
   } else {
      throw "names must be type of object";
   }
   return Cookies;
};

export default Cookies;
